import {
  promoCodeIcon,
  accountIcon,
  rolesIcon,
  regionIcon,
  areaIcon,
  ProductIcon,
  CompanyIcon,
  PlantIcon,
  StoreIcon,
  StoreGrpIcon,
  TaxIcon,
  SectionIcon,
  ServicesIcon,
  PreferenceIcon,
  ProductSpecificationIcon,
  UpchargeIcon,
  GalleryIcon,
  OrderCreationIcon,
  loyaltyIcon,
  GroupIcon,
  CustomerListIcon,
  OrganizationIcon,
  ProfessionIcon,
  RedeemIcon,
  PriceListIcon,
  HomeCleanOrdersIcon,
  HomeCleanProductIcon,
  HomeCleanSettingsIcon,
  ReceiptPrinterIcon,
  MetalProgettiIcon,
  GarmentTagPrinterIcon,
  businessAccountsIcon,
  customerGroupsIcon,
  customersIcon,
  productMasterIcon,
  geofenceIcon,
  companyB2BIcon,
  lateDeliveryIcon,
  pushPinIcon
} from "./assets";

export interface ISubPermissionGroup {
  id: number;
  name: string;
  permitted: boolean;
  sub_group_key: string
}

export interface PermissionGroupArray {
  id: number;
  name: PermissionName;
  permitted: boolean;
  permission_sub_groups: Array<ISubPermissionGroup>;
  permission_group_key:
    | "company_apis"
    | "role_apis"
    | "account_apis"
    | "plant_apis"
    | "service_apis"
    | "specification_apis"
    | "product_apis"
    | "section_apis"
    | "store_management_apis"
    | "region_apis"
    | "area_apis"
    | "preference_list_apis";
}

interface StoreManagements {
	id: string;
	type: string;
	store_name: string;
	store_id: number;
}

export interface IMyUser {
  attributes: {
    first_name: string;
    email: string;
    last_name: string;
    full_name: string;
    activated: boolean;
    employee_proifle: {
      data: {
        id: string;
        attributes: {
          profile_logo: null | string;
          plant_section: null | string;
          region_manager_id: number | null;
          region_manager_name: string | null;
          store_management_id: number;
          region: {
            data: {
              attributes: {
                id: number;
                branch_name: string;
                branch_short_name: string;
              };
            };
          };
          region_ids: string[];
          store_management_ids: number[];
          store_management: {
            store_id: number;
            store_name: string;
            attributes: {
              id: number;
              is_process_cleaning_products: boolean;
              payment_method_screen: boolean;
              item_preference_popup: boolean;
              price_list_id: number;
              sections: {
                name: string;
                id: number;
              }[];
            };
          };
          store_managements: StoreManagements[]
          share_folders: string[]
        };
      };
    };
    role?: {
      id: 117;
      name: "SuperAdmin" | string;
      created_at: string;
      updated_at: string;
      active: boolean;
      icon_id: number;
      role_permissions_count: number;
    };
    permission_groups: [PermissionGroupArray];
  };
}

export type PermissionName = "Advance Search"
  | "Company"
  | "B2B Company"
  | "Role Assignment"
  | "B2b Dashboard"
  | "B2b Advance Search"
  | "Account Creation"
  | "Plant Creation"
  | "Services Creation"
  | "Upcharge List Creation"
  | "Specifications Management"
  | "Products Management"
  | "Sections Management"
  | "Company Activation"
  | "Role Activation"
  | "Account Activation"
  | "Plant Activation"
  | "Store Management"
  | "Order Creation"
  | "Aljabr Store"
  | "Tax calculator"
  | "Store Management Activation"
  | "Services Activation"
  | "Specifications Management Activation"
  | "Upcharge List Activation"
  | "Region Creation"
  | "Region Activation"
  | "Area Creation"
  | "Area Activation"
  | "Preference List Creation"
  | "Preference List Activation"
  | "Products Activation"
  | "Loyalty System"
  | "Section Activation"
  | "Organisation"
  | "Customer Type Management"
  | "Promo Code"
  | "Invite Friend Module"
  | "Gallery Module"
  | "Plant Order Management"
  | "Home cleaning setting"
  | "Home Cleaning Product"
  | "Price List Management"
  | "Laundry order management"
  | "Carpet and furniture cleaning Orders"
  | "Home cleaning Orders"
  | "Transfer Request"
  | "Region"
  | "Area"
  | "Store"
  | "Tax"
  | "Invite Friend"
  | "Product Specifications"
  | "Product"
  | "Account"
  | "Preference"
  | "Customer"
  | "Service"
  | "Section"
  | "Gallery"
  | "Price List"
  | "Upcharge"
  | "Role"
  | "Customer Type"
  | "Plant"
  | "Profession"
  | "Order"
  | "Cashier"
  | "Cashup"
  | "Plant management"
  | "Other Permission"
  | "Permanent Tag"
  | "Dashboard"
  | "Report Export"
  | "Hardware"
  | "Customer Group"
  | "Business Account Customer"
  | "Business Account"
  | "Product Master"
  | "Catalogue"
  | "B2b Order"
  | "B2B Reports"
  | "B2b Report Export"
  | "Report Scheduler"
  | "Mobile App"
  | "Driver App"
  | "Store Discount"
  ;

export interface IMenuItems {
  0: React.ReactNode | string;
  1: string;
  2: string | string[];
  3: string;
  4: PermissionName;
  5?: PermissionName[]; // additional permissions
  6?: string
}

type Key = string | number;
export interface Attributes {
  key?: Key | null;
}

export const productsModuleMenuItems: IMenuItems[] = [
  [PriceListIcon, "Price List", "PriceList", "Products", "Price List"],
  [SectionIcon, "Section", "SectionList", "Products", "Section"],
  [ServicesIcon, "Services", "ServicesList", "Products", "Service"],
  [
    UpchargeIcon,
    "Upcharge",
    "UpchargeList",
    "Products",
    "Upcharge",
  ],
  [
    ProductSpecificationIcon,
    "Product Specification",
    "SpecificationList",
    "Products",
    "Product Specifications",
  ],
  [
    PreferenceIcon,
    "Preference",
    "PreferenceList",
    "Products",
    "Preference",
  ],
  [ProductIcon, "Product", "ProductList", "Products", "Product"],
  [GalleryIcon, "Gallery", "Gallery", "Products", "Gallery"],
];

export const generalModuleMenuItems: IMenuItems[] = [
  [CompanyIcon, "Company", "CompanyList", "General", "Company"],
  [regionIcon, "Region", "RegionList", "General", "Region"],
  [areaIcon, "Area", "AreaList", "General", "Area"],
  [PlantIcon, "Plant", "PlantList", "General", "Plant"],
  [StoreIcon, "Store", "StoreList", "General", "Store"],
  [StoreGrpIcon, "Store Group", "StoreGroupList", "General", "Other Permission",[],"grouping_store"],
  [TaxIcon, "Tax", "TaxList", "General", "Tax"],
  [lateDeliveryIcon, "Late Delivery", "LateDeliveryList", "General", "Other Permission"],
  [pushPinIcon, "Permanent Tags", "PermanentTagsList", "General", "Permanent Tag", [], "read"],
];

export const customerModuleMenuItems: IMenuItems[] = [
  [
    GroupIcon,
    "Customer Type",
    "CustomerType",
    "Customer",
    "Customer Type",
  ],
  [
    CustomerListIcon,
    "Customer List",
    "PeopleManagement2",
    "Customer",
    "Customer",
  ],
  [
    OrganizationIcon,
    "Organization",
    "OrganizationList",
    "Customer",
    "Organisation",
  ],
  [
    ProfessionIcon,
    "Profession",
    "ProfessionList",
    "Customer",
    "Profession",
  ],
  [
    RedeemIcon,
    "Invite Codes / Referral",
    "Invitefriends",
    "Customer",
    "Invite Friend",
  ],
];

export const homeCleanMenuItems: IMenuItems[] = [
  [
    HomeCleanSettingsIcon,
    "Home Cleaning Settings",
    "HomeCleaningSettingsList",
    "homeCleanProduct",
    "Home cleaning setting",
  ],
  [
    HomeCleanProductIcon,
    "Home Products",
    "HomeCleaningProductList",
    "homeCleanProduct",
    "Home Cleaning Product",
  ],
  [
    HomeCleanOrdersIcon,
    "Home Orders",
    "HomeCleaningOrders",
    "homeCleanProduct",
    "Home cleaning Orders",
  ],
];

export const settingMenuItems: IMenuItems[] = [
  [
    rolesIcon,
    "Roles and Permission",
    "RolesPermissions",
    "Setting",
    "Role",
  ],
  [accountIcon, "Account", "Account", "Setting", "Account"],
];

export const storeModuleMenuItems: IMenuItems[] = [
  [
    OrderCreationIcon,
    "Orders Creation",
    "OrderCreation",
    "StoreManage",
    "Order",
    ["Carpet and furniture cleaning Orders"],
    "create"
  ],
  [ 
    StoreIcon, 
    "Orders", 
    "Orders", 
    "StoreManage", 
    "Order", 
    ["Carpet and furniture cleaning Orders"],
    "read"
  ],
  [
    OrderCreationIcon,
    "Aljabr Store",
    "AljabrStore",
    "StoreManage",
    "Order",
    ["Carpet and furniture cleaning Orders"],
    "create"
  ],
  // Hidden from the nav for now — the route stays registered in App.js, so
  // /StoreManage-MobileRequests is still reachable directly. Restore this entry
  // to bring it back.
  // [
  //   StoreIcon,
  //   "Mobile Requests",
  //   "MobileRequests",
  //   "StoreManage",
  //   "Order",
  //   [],
  //   "read"
  // ],
];

export const marketingModuleMenuItems: IMenuItems[] = [
  [loyaltyIcon, "Loyalty System", "LoyaltyList", "Marketing", "Loyalty System"],
  [promoCodeIcon, "Promo Code", "PromoCode", "Marketing", "Promo Code"],
  [promoCodeIcon, "Promotions", "Promotions", "Marketing", "Promo Code"],
  [loyaltyIcon, "Golden Points", "GoldenPointList", "Marketing", "Loyalty System"],
  [promoCodeIcon, "Store Discount", "StoreDiscountList", "Marketing", "Store Discount"],
];
// Gated by the "Mobile App" permission group; the 7th entry is the
// permission_sub_groups sub_group_key each item needs.
export const mobileAppMenuItems: IMenuItems[] = [
  [StoreIcon, "Banners", "BannerList", "MobileApp", "Mobile App", [], "banners"],
  [StoreIcon, "Stores", "MobileStoreList", "MobileApp", "Mobile App", [], "stores"],
  [StoreIcon, "Slot Management", "SlotManagementList", "MobileApp", "Mobile App", [], "slot_management"],
];

// Sidebar section rendered directly below "Mobile App".
// Entries: [icon, label, routeKey (from App.js routeMap), route prefix, permission, extraPermissions?, featureKey?]
export const driverAppMenuItems: IMenuItems[] = [
  [StoreIcon, "Driver Tracker", "DriverTracker", "DriverApp", "Driver App", [], "driver_tracker"],
  [StoreIcon, "Driver Attendance", "DriverAttendance", "DriverApp", "Driver App", [], "driver_attendance"],
];

export const hardwareModuleMenuItems: IMenuItems[] = [
  [ReceiptPrinterIcon, "Receipt Printer", "ReceiptPrinter", "Hardware",  "Hardware", [], "receipt_printer_access"],
  [GarmentTagPrinterIcon, "Garment Tag Printer", "GarmentTagPrinter", "Hardware", "Hardware", [], "garment_tag_printer_access"],
  [MetalProgettiIcon, "Metal Progetti", "MetalProgetti", "Hardware","Hardware", [], "metal_progetti_access"],
];

export const headerConfig = {
  search: [
    "/Cfplantdashboard2",
    "/Dashboard-PlantReport",
    "/cashier-IncomingTransaction",
    "/cashier-OutGoingTransaction",
    "/Products-PriceList",
    "/Products-SectionList",
    "/Products-ServicesList",
    "/Products-UpchargeList",
    "/Products-SpecificationList",
    "/Products-PreferenceList",
    "/StoreManage-Orders",
    "/Products-ProductList",
    "/Products-Gallery",
    "/Products-GalleryAddImageIcon",
    "/Marketing-LoyaltyList",
    "/PromoCode",
    "/Marketing-CustomerType",
    "/cashup",
    "/StoreManage-OrderCreation",
    "/StoreManage-AljabrStore",
    "/Settings-RolesPermissions",
    "/Settings-Account",
    "/Settings-General-CompanyList",
    "/Settings-General-RegionList",
    "/Settings-General-AreaList",
    "/Settings-General-PlantList",
    "/Settings-General-StoreList",
    "/Settings-General-StoreGroupList",
    "/Settings-General-Taxlist",
    "/Settings-General-LateDeliveryList",
    "/Settings-General-PermanentTagsList",
    "/Marketing-Customer-PeopleManagement2",
    "/Marketing-Customer-OrganizationList",
    "/Marketing-ProfessionList",
    "/B2BSettings-B2BCustomerList",
    "/B2BSettings-B2bCustomerGroup",
    "/B2bMasterProduct",
    "/B2BSettings-B2bMasterProduct",
    "/B2BSettings-B2bBusinessAccountList",
    "/B2BCompanyList",
    "/B2BSettings-B2BPriceList",
    "/ZatcaHistory"
  ],
  hideActivePassiveUsers: ["/Cfplantdashboard2","/SalesReporting","/ReportScheduler"],
  printerSettings: ["/AdvancedSearch","/StoreManage-Orders"],
  multiRegionDropdown: [
    "/Dashboard-Main",
    "/Dashboard-Overview",
    "/Dashboard-SectionSales",
    "/Dashboard-PlantReport",
    "/Dashboard-PopularTimes",
    "/Dashboard-Sales",
    "/Dashboard-Revenue",
    "/Dashboard-Customer",
    "/Dashboard-DiscountCredit",
    "/Dashboard-AdvanceSalesDashboard",
    "/Dashboard-TopSellingItems",
    "/CfCashier",
    "/cashier-IncomingTransaction",
    "/cashier-OutGoingTransaction",
    "/cashup",
    "/SalesReporting",
    "/B2bOrderReport"
  ],
  storeAndGroupChange: [
    "/Dashboard-Main",
    "/Dashboard-Overview",
    "/Dashboard-SectionSales",
    "/Dashboard-PlantReport",
    "/Dashboard-PopularTimes",
    "/Dashboard-Sales",
    "/Dashboard-Revenue",
    "/Dashboard-Customer",
    "/Dashboard-DiscountCredit",
    "/Dashboard-AdvanceSalesDashboard",
    "/Dashboard-TopSellingItems",
    "/SalesReporting",
    "/B2bOrderReport",
  ],
  singleSelectStore: ["/StoreManage-Orders","/StoreManage-OrderCreation","/StoreManage-AljabrStore","/StoreManage-MobileRequests","/DriverApp-DriverTracker"],
  multiSelectStore: [
    "/cashier",
    "/cashier-IncomingTransaction",
    "/cashier-OutGoingTransaction",
    "/Cfplantdashboard2",
    "/cashup",
    "/ZatcaHistory"
  ]
};

export const b2bSettingMenuItems: IMenuItems[] = [
  [businessAccountsIcon,"B2B Business Accounts",["B2bBusinessAccountList","BusinessAccountAdd","BusinessAccountView","BusinessAccountEdit"],"B2BSettings", "Business Account"],
  [customersIcon, "B2B Customers", "B2BCustomerList", "B2BSettings", "Business Account Customer"],
  [customerGroupsIcon, "B2B Customer Groups", ["B2bCustomerGroup","B2bAddCustomerGroup","ViewCustomerGroup"], "B2BSettings", "Customer Group"],
  [productMasterIcon, "B2B Product Master", ["B2bMasterProduct","ProductListAdd","ProductListView","ProductListEdit"], "B2BSettings", "Product Master"],
  [productMasterIcon, "B2B Price List", "B2BPriceList", "B2BSettings", "Catalogue"],
];

export const B2bGeneralModuleMenuItems: IMenuItems[] = [
  [companyB2BIcon, "B2B Company", ["B2BCompanyList","CompanyListAdd","CompanyListEdit","CompanyListView"], "General", "B2B Company"],
];

export const B2bsettingMenuItems: IMenuItems[] = [
  [
    rolesIcon,
    "Roles and Permission",
    "RolesPermissions",
    "Setting",
    "Role",
  ],
];

export const b2bStoreModuleMenuItems: IMenuItems[] = [
  [
    OrderCreationIcon,
    "Orders Creation",
    "OrderCreation",
    "StoreManage",
    "B2b Order",
    [],
    "create"
  ],
  [ 
    StoreIcon, 
    "B2B Orders", 
    "Orders", 
    "StoreManage", 
    "B2b Order", 
    [],
    "read"
  ],
];